import {
  Plugin,
} from 'ckeditor5';
import Editing from 'views/EMR/components/ckeditor-plugins/Temporary/editing';

export default class Temporary extends Plugin {
  static get requires() {
    return [Editing];
  }

  public static get pluginName() {
    return 'Temporary' as const;
  }
}
